import React, { useState } from "react";
import axios from "axios";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../store/helpers/mapState";
import { connect } from "react-redux";
import { Alert } from "@mui/material";
import ifLogoWhite from "../../assets/img/if-logo.png";
import secureLocalStorage from "react-secure-storage";
import OpenDocument from "helpers/openDocument";

function ForgotPassword(props) {
  const { errorMessage, successMessage } = props;
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(null);

  const settings = secureLocalStorage.getItem("systemSettings");
  const systemSettings = JSON.parse(settings);
  const backgroundColor = systemSettings?.mainBackground ?? "bg-blueGray-800";

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/user/forgot-password", { email });
      if (res.status !== 200) {
        throw new Error("Failed to send reset link");
      }
      setMessage(res.data.message);
    } catch (err) {
      setMessage("Error sending reset link");
    }
  };

  return (
    <>
      <main className="overflow-hidden">
        <div className="relative flex items-center justify-center w-full h-full">
          <div className="absolute top-0 w-full h-full bg-center bg-cover"></div>

          <div className="relative container mx-auto px-0 h-full">
            <div className="flex flex-col content-center items-center justify-center h-full">
              <div className="rounded-t mb-0 px-6 py-6">
                <div className="text-center">
                  {/* <img
                                        src={ifLogoWhite}
                                        alt="IF Logo"
                                        className="h-16 w-auto"
                                    /> */}
                  <OpenDocument
                    mimeType={"image"}
                    document={systemSettings?.logoImage}
                    downloadable={false}
                    type={"logo"}
                    imgClassName="h-16 w-auto"
                  />
                </div>
              </div>
              <div className="w-full lg:w-4/12 px-4">
                <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                  <div className="flex-auto px-4 lg:px-8 py-8">
                    {(errorMessage || successMessage) && (
                      <div>
                        <Alert
                          className="mb-3"
                          severity={successMessage ? "success" : "error"}
                          onClose={() => {}}
                        >
                          {successMessage ?? errorMessage}
                        </Alert>
                      </div>
                    )}
                    <form
                      onSubmit={handleSubmit}
                      className="max-w-md mx-auto bg-white p-6 rounded shadow"
                    >
                      <h2 className="text-2xl mb-4">Forgot Password</h2>
                      {message && (
                        <div className="mb-4 text-sm text-red-600">
                          {message}
                        </div>
                      )}

                      <div className="relative w-full mb-3">
                        <div className="relative flex items-center mt-1">
                          <input
                            type="email"
                            required
                            name="email"
                            className="border border-input px-3 py-3 pl-10 placeholder-blueGray-300 text-black bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                            placeholder="Enter your email"
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                          />
                          <img
                            src={require("../../assets/img/Email.svg").default}
                            alt="Email Icon"
                            className="absolute left-4 top-1/2 transform -translate-y-1/2 w-5 h-5"
                          />
                        </div>
                      </div>

                      {!message && (
                        <div className="text-center mt-3">
                          <button
                            className={` "bg-blueGray-800"
                                                        } flex justify-center text-white active:bg-blueGray-600 text-sm font-bold uppercase px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 w-full ease-linear transition-all duration-150 bg-primary `}
                            type="submit"
                            style={{ backgroundColor: "#56677d" }}
                          >
                            Send Reset Link
                          </button>
                        </div>
                      )}
                    </form>

                    <div className="mt-3 text-center">
                      <span className="text-gray-500 text-sm">
                        Can't access?{" "}
                      </span>
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.qtglobal.rw/contact"
                        // onClick={(e) => e.preventDefault()}
                        className="text-blue-600 text-sm"
                      >
                        Contact Admin
                      </a>
                    </div>
                  </div>
                </div>

                <div className="flex flex-wrap mt-6 relative">
                  <div className="w-1/2">
                    <a
                      href="#create-account"
                      onClick={(e) => e.preventDefault()}
                      className="text-blueGray-200"
                    ></a>
                  </div>
                  <div className="w-1/2 text-right"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
